// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-4bf51cd9] {\n  position: relative;\n}\n.wrapper .floatBtn[data-v-4bf51cd9] {\n  position: absolute;\n  right: 10px;\n  bottom: 60px;\n  z-index: 9999;\n}\n.wrapper .floatBtn div[data-v-4bf51cd9] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
